export const TICKET_SUMMARY_QUERY_CONTEXT_PREFIX = 'TicketSummaryQueryContextProvider';
